import {
	Autocomplete,
	InputLabel,
	InputAdornment,
	TextField,
	Stack,
} from '@mui/material';

import React from 'react';

import { ReactComponent as SearchOutlined } from 'common/assets/images/search-outline.svg';

import styles from './SearchableDropdown.module.scss';

type Options = {
	label: string | number;
	value: string | number;
};

interface ISearchProps {
	placeholder: string;
	searchList: Options[];
	value: any;
	label: string;
	onChange: (e: Options) => void;
}

const SearachableDropdown = (props: ISearchProps) => {
	const { label, onChange, value, searchList, placeholder } = props;

	const searchOptions = searchList.map((option: any) => ({
		label: option.label,
		value: option.value,
	}));

	return (
		<Stack>
			<InputLabel shrink className={styles['font-bold']}>
				{label}
			</InputLabel>
			<Autocomplete
				disablePortal
				id="combo-box-demo"
				options={searchOptions}
				data-testid="select-dropdown"
				getOptionLabel={(option) => option.label}
				className={styles['search-field-size']}
				isOptionEqualToValue={(option: any, value: any) =>
					value === undefined || value === '' || option.value === value.value
				}
				renderInput={(params) => (
					<TextField
						placeholder={placeholder}
						{...params}
						data-testid="search-field"
						InputProps={{
							...params.InputProps,
							type: 'search',
							startAdornment: (
								<InputAdornment position="start">
									<SearchOutlined className={styles['input-search-icon']} />
								</InputAdornment>
							),
						}}
					/>
				)}
				value={value}
				onChange={(event: any, newValue: any | null) => onChange(newValue)}
				// freeSolo // To allow to enter random values and can press enter
			/>
		</Stack>
	);
};

export default SearachableDropdown;
